module.exports = __webpack_public_path__ + "img/message_105089.b0bd0594.png";